import { generateID } from './PanelTemplatesTheme/helpers';
import { WIDGET_LABEL_SIZE } from '../../components/Widget/WidgetLabel/constants';
import { Panel } from '../../models/Panel/Panel';

export var TemplateEditorial4: Panel = {
    id: 'editorial-4',
    name: 'Right Aligned Image w/ Text',
    description: '',
    tags: ['Editorial', 'text', 'image', 'landscape', 'portrait', 'interstitial'],
    widget: {
        id: generateID(),
        position: {
            width: '1920px',
            height: '1080px',
            top: '0',
            left: '0',
        },
        classes: 'template_custom',
        label: {
            titleText: 'Panel',
            enabled: false,
            size: WIDGET_LABEL_SIZE.primary,
        },
        children: [
            {
                type: 'customContentRichText',
                id: generateID(),
                position: {
                    width: '40%',
                    height: '15%',
                    top: '10%',
                    left: '5%',
                    portrait: {
                        width: '80%',
                        height: '8%',
                        top: '5%',
                        left: '10%',
                    },
                },
                label: {
                    titleText: 'Widget Header',
                    enabled: false,
                    size: WIDGET_LABEL_SIZE.primary,
                },
                options: {
                    player: {
                        playing: false,
                        duration: 15,
                    },
                    contentRichText: {
                        entityMap: {},
                        blocks: [
                            {
                                key: 'ag6qs',
                                text: 'Main Header',
                                type: 'unstyled',
                                depth: 0,
                                inlineStyleRanges: [
                                    {
                                        offset: 0,
                                        length: 11,
                                        style: 'BOLD',
                                    },
                                    {
                                        offset: 0,
                                        length: 11,
                                        style: 'CUSTOM_FONT_SIZE_20' as any,
                                    },
                                ],
                                entityRanges: [],
                                data: {},
                            },
                        ],
                    },
                    contentPadding: 5,
                    contentTextAlign: 'left',
                    verticalAlign: 'top',
                },
            },
            {
                type: 'customContentRichText',
                name: 'Rich Text',
                id: generateID(),
                position: {
                    width: '40%',
                    height: '15%',
                    top: '23%',
                    left: '5%',
                    portrait: {
                        width: '80%',
                        height: '8%',
                        top: '13%',
                        left: '10%',
                    },
                },
                label: {
                    titleText: 'Widget Header',
                    enabled: false,
                    size: WIDGET_LABEL_SIZE.primary,
                },
                options: {
                    player: {
                        playing: false,
                        duration: 15,
                    },
                    contentRichText: {
                        entityMap: {},
                        blocks: [
                            {
                                key: 'ag6qs1',
                                text: 'Subheader',
                                type: 'unstyled',
                                depth: 0,
                                inlineStyleRanges: [
                                    {
                                        offset: 0,
                                        length: 9,
                                        style: 'CUSTOM_FONT_SIZE_18' as any,
                                    },
                                ],
                                entityRanges: [],
                                data: {},
                            },
                        ],
                    },
                    contentPadding: 5,
                    contentTextAlign: 'left',
                    verticalAlign: 'top',
                },
            },
            {
                type: 'customContentImage',
                id: '3',
                name: 'Image',
                position: {
                    width: '50%',
                    height: '100%',
                    top: '0',
                    left: '50%',
                    portrait: {
                        width: '100%',
                        height: '50%',
                        top: '50%',
                        left: '0',
                    },
                },
                label: {
                    titleText: 'Header',
                    enabled: false,
                    size: WIDGET_LABEL_SIZE.primary,
                },
                options: {
                    player: {
                        playing: false,
                        duration: 15,
                    },
                    contentImageFit: 'cover',
                    contentImageUrl: '/public/assets/MomentofHappiness1.jpg',
                },
            },
        ],
    },
};
